<template>
	<section id="404-section" class="content-404">
		<div class="container-fluid ">
			<b-row>
				<b-col class="text-center" cols="12">
					<p class="code404"><b>404</b></p>
					<h2 class="messageEr">{{ $t("error.messageError") }}</h2>
					<br><br><br>
				</b-col>
			</b-row>
		</div>
		<FooterComponent class="fot"></FooterComponent>
	</section>
	
</template>

<script>
import FooterComponent from './FooterComponent'
export default {
  name: 'Component404',
  components:{
    FooterComponent
  },
}
</script>

<style>

.content-404{
	background-color: #22C3D1;
	height: 70vh;
}
.messageEr{
	font-family: "Gotham Bold Regular";
	font-size: 42px;
	line-height: 2px;
}
.code404{
	font-size: 14rem;
}

.fot{
   position:fixed;
   left:0px;
   bottom:0px;
   /* height:30px; */
   width:100%;
   /* background:#999; */
}

@media screen and (max-width: 1800px) and (min-width: 961px){
	.code404{
		font-size: 9rem;
	}
	.messageEr{
		font-family: "Gotham Bold Regular";
		font-size: 35px;
		line-height: 2px;
	}
	
}

@media screen and (max-width: 960px) and (min-width: 100px){

	.content-404{
		background-color: #22C3D1;
		height: 100vh;
	}
	.code404{
		font-size: 5rem;
	}
	.messageEr{
		font-family: "Gotham Bold Regular";
		font-size: 20px;
		line-height: 2px;
	}
	.fot{
		position:relative;
		left:0px;
		bottom:50px !important;
		padding-top: 10px !important;
		/* height:30px; */
		width:100%;
		/* background:#999; */
	}
	
}


</style>